import { PostHogProvider } from '@posthog/react';
import type { ReactNode } from 'react';
import { posthog } from './analytics';

/**
 * Wraps the app with the official PostHog React provider so any
 * component can `import { usePostHog } from '@posthog/react'` and
 * grab the client. The provider is a no-op when initAnalytics()
 * never ran (e.g. VITE_POSTHOG_KEY missing) — posthog-js exports a
 * stub that swallows calls.
 */
export function AnalyticsProvider({ children }: { children: ReactNode }) {
  return <PostHogProvider client={posthog}>{children}</PostHogProvider>;
}
